import { API } from '@/api';

export const classes = {
  menu: 'px-4 pb-2 pt-4 m-2 max-w-[98vw] w-[375px]',
  wrapper: 'px-2',
  titleWrapper: 'place-start mb-4',
  details: 'mt-2 mb-4',
  title:
    'text-grey-8 text-lg font-medium cursor-pointer hover:underline dark:text-mauve-1',
  description: 'text-grey-8 leading-5 text-base font-normal dark:text-mauve-2',
  dueAt: 'text-grey-7 text-base font-normal ml-2 dark:text-mauve-1',
};

export async function updateIsResolved(taskId: number, isResolved: boolean) {
  return API.Tasks.updateTask(taskId, { isResolved });
}
